module.exports = __webpack_public_path__ + "img/u19547.78723c86.png";